export const MOBILE_SDK_SINGLE_TEST_TABS_LABELS = {
	OVERVIEW: 'Overview',
	ALL_ISSUES: 'All Issues',
	SCANS: 'Scans'
} as const;
